module.exports = __webpack_public_path__ + "static/media/frameshop_1.076974fb.jpg";